"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPropertyLogoLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const shared_1 = require("../../../shared");
const LegacyPropertyLogoLink = ({ logoLink = {}, locale, className }) => {
    var _a, _b;
    const { messages } = (0, shared_1.useMessages)();
    const theme = (0, epic_games_nav_shared_1.useTheme)();
    const useNode = !!((_a = theme === null || theme === void 0 ? void 0 : theme.logo) === null || _a === void 0 ? void 0 : _a.node);
    let finalHref = logoLink.href;
    if (logoLink.useCustomCallback) {
        const { localeHref } = (0, epic_games_nav_shared_1.getHrefWithLocale)({ href: finalHref, hrefTemplate: logoLink.hrefTemplate, locale });
        finalHref = localeHref;
    }
    const onClick = (0, react_1.useCallback)((e) => {
        if (logoLink.useCustomCallback) {
            if ((logoLink === null || logoLink === void 0 ? void 0 : logoLink.onClick) && typeof logoLink.onClick === "function") {
                logoLink.onClick(e);
            }
            else {
                e.preventDefault();
                (0, epic_games_nav_shared_1.navigateWithHref)(finalHref, locale);
            }
        }
    }, [logoLink.useCustomCallback, logoLink.onClick, locale]);
    const onKeyUp = (0, shared_1.useHandleKeyUp)(onClick);
    return (react_1.default.createElement("a", { role: "button", "aria-label": messages.propLogoLabel, id: "propLogo", href: finalHref, className: className, onClick: onClick, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, onKeyUp: onKeyUp }, useNode && ((_b = theme === null || theme === void 0 ? void 0 : theme.logo) === null || _b === void 0 ? void 0 : _b.node)));
};
exports.LegacyPropertyLogoLink = LegacyPropertyLogoLink;
//# sourceMappingURL=LegacyPropertyLogoLink.js.map